"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithRef } from "react";
import { useState } from "react";
import { cn } from "@/lib/utils";
export interface CopyButtonProps extends Omit<ComponentPropsWithRef<"button">, "aria-label" | "onClick"> {
  getCodeAction: () => string;
}
export function CopyButton(t0) {
  const $ = _c(16);
  let className;
  let getCodeAction;
  let rest;
  if ($[0] !== t0) {
    ({
      getCodeAction,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = getCodeAction;
    $[3] = rest;
  } else {
    className = $[1];
    getCodeAction = $[2];
    rest = $[3];
  }
  const [isCopied, setIsCopied] = useState(false);
  let t1;
  if ($[4] !== getCodeAction) {
    t1 = async () => {
      if (!navigator?.clipboard) {
        console.warn("Clipboard not supported");
        return;
      }
      ;
      try {
        const code = getCodeAction();
        await navigator.clipboard.writeText(code);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (t2) {
        const error = t2;
        console.warn("Copy failed", error);
        setIsCopied(false);
      }
    };
    $[4] = getCodeAction;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const copy = t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("border/10 z-10 flex size-4 cursor-pointer items-center rounded-md bg-gray-700/10 p-0.5 text-xs text-gray-200 outline-none hover:bg-gray-600/20 focus:outline-none sm:size-8 sm:p-1", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = isCopied ? "Copied!" : "Copy to Clipboard";
  let t4;
  if ($[8] !== isCopied) {
    t4 = isCopied ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" role="img" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-4"><path d="M20 6 9 17l-5-5" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-4"><rect width="14" height="14" x="8" y="8" rx="2" ry="2" /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></svg>;
    $[8] = isCopied;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== copy || $[11] !== rest || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <button {...rest} onClick={copy} className={t2} aria-label={t3}>{t4}</button>;
    $[10] = copy;
    $[11] = rest;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
CopyButton.displayName = "CopyButton";